module.exports = __webpack_public_path__ + "static/media/Faiz_AM.d949c988.jpg";